import { AuthErrorResponse, AxiosApiError, LOGIN_ERROR_STATUS } from 'api';

import {
  GENERIC_ERROR_MESSAGE,
  LOGIN_ERROR_MESSAGE,
  LOGIN_NON_SPAREMIN_ERROR_MESSAGE,
} from './constants';

export const getLoginFormError = (
  errResponse?: AxiosApiError<AuthErrorResponse>,
): string => {
  if (errResponse?.response?.status === LOGIN_ERROR_STATUS) {
    if (errResponse.response?.data.errorDetails?.isNonSpareminAuthAvailable) {
      return LOGIN_NON_SPAREMIN_ERROR_MESSAGE;
    }
    return LOGIN_ERROR_MESSAGE;
  }

  return GENERIC_ERROR_MESSAGE;
};
